<template>
  <div class="stats stats-horizontal h-fit shrink-0 shadow">
    <RouterLink
      :class="[
        'stat bg-base-100 transition-all hover:brightness-95',
        isLoading
          ? 'pointer-events-none cursor-not-allowed opacity-60'
          : 'cursor-pointer',
      ]"
      :to="{
        name: $route.name,
        params: $route.params,
        query: {
          ...$route.query,
          status: undefined,
        },
      }"
    >
      <div class="stat-title">Tổng số</div>
      <div class="stat-value">
        <template v-if="isLoading">
          <span
            class="bg-base-300 inline-block h-6 w-16 animate-pulse rounded"
          ></span>
        </template>
        <template v-else>{{ total }}</template>
      </div>
    </RouterLink>

    <RouterLink
      :class="[
        'stat bg-base-100 transition-all hover:brightness-95',
        isLoading
          ? 'pointer-events-none cursor-not-allowed opacity-60'
          : 'cursor-pointer',
      ]"
      :to="{
        name: $route.name,
        params: $route.params,
        query: {
          ...$route.query,
          status: 'online',
        },
      }"
    >
      <div class="stat-title">Online</div>
      <div class="stat-value text-success">
        <template v-if="isLoading">
          <span
            class="bg-base-300 inline-block h-6 w-12 animate-pulse rounded"
          ></span>
        </template>
        <template v-else>{{ onlineCount }}</template>
      </div>
    </RouterLink>

    <RouterLink
      :class="[
        'stat bg-base-100 transition-all hover:brightness-95',
        isLoading
          ? 'pointer-events-none cursor-not-allowed opacity-60'
          : 'cursor-pointer',
      ]"
      :to="{
        name: $route.name,
        params: $route.params,
        query: {
          ...$route.query,
          status: 'offline',
        },
      }"
    >
      <div class="stat-title">Offline</div>
      <div class="stat-value text-base-content/60">
        <template v-if="isLoading">
          <span
            class="bg-base-300 inline-block h-6 w-12 animate-pulse rounded"
          ></span>
        </template>
        <template v-else>{{ offlineCount }}</template>
      </div>
      <div class="stat-desc">
        {{ offlineUninstalledCount }} máy đã gỡ cài đặt
      </div>
    </RouterLink>
  </div>
</template>

<script setup lang="ts">
import { useClientStatisticsQuery } from "@/composables/clients";
import { router } from "@/router/router";
import { computed } from "vue";

const campaignId = computed(() => {
  return router.currentRoute.value.params.campaign_id?.toString() ?? undefined;
});

const { isLoading, data } = useClientStatisticsQuery(campaignId.value);

const total = computed(() => data.value?.reduce((a, c) => a + c.total, 0) ?? 0);

const onlineCount = computed(
  () => data.value?.find((s) => s._id === "online")?.total ?? 0,
);

const offlineCount = computed(
  () => data.value?.find((s) => s._id === "offline")?.total ?? 0,
);

const offlineUninstalledCount = computed(
  () =>
    data.value
      ?.find((s) => s._id === "offline")
      ?.items?.filter((item) => item.uninstalled)
      .reduce((a, c) => a + c.count, 0) ?? 0,
);
</script>
